import { createStore } from "vuex";

import authInit from "./authInit";

import user from "./user";
import membership from "./membership";

export default createStore({
  state: {
    appLoaded: false,
    initError: null,
  },
  getters: {
    getAppLoadedState(state) {
      return state.appLoaded;
    },
    getInitError(state) {
      return state.initError;
    },
  },
  mutations: {
    SET_APP_LOADED_STATE(state, payload) {
      state.appLoaded = payload;
    },
    SET_INIT_ERROR(state, payload) {
      state.initError = payload;
    },
  },
  actions: {
    authInit,
  },
  modules: {
    user,
    membership,
  },
});
